const $navMega = {
  trigger: document.querySelectorAll('.js-c-Header__navItem--mega'),
  item: document.querySelectorAll('.js-c-Header__navItemMega')
};

for(let i = 0; i < $navMega.trigger.length; i++) {
  $navMega.trigger[i].addEventListener('mouseover', function(){
    $navMega.item[i].classList.add('is-show');
  });

  $navMega.trigger[i].addEventListener('mouseout', function(){
    $navMega.item[i].classList.remove('is-show');
  });
}
